"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sl: {
    "shoppingLists": {
      "actions": {
        "insert": "Dodaj v košarico",
        "rename": "Preimenuj"
      },
      "shoppingListsDialog": {
        "title": "Moji nakupovalni seznami"
      },
      "saveShoppingListDialog": {
        "title": "Shranit nakupovalni seznam pod imenom",
        "shoppingListName": {
          "label": "Ime seznama",
          "helperText": "Poimenujte nakupovalni seznam. Pozneje ga boste prepoznali po imenu. Ime lahko spremenite pozneje.",
          "helperTextPreview": ""
        }
      },
      "shoppingListItemCollapsed": {
        "quantity": "ks"
      }
    }
  }
};
var _default = messages;
exports.default = _default;